import { RouteRecordRaw } from "vue-router";

export default [
  {
    path: "/demo/:projectId",
    name: "DemoPage",
    component: () => import("@/views/demo/DemoPage.vue"),
    meta: {
      title: "自动播出测试",
      ignoreAuth: true,
      hideMenu: true,
    },
  },
] as RouteRecordRaw[];
